export default __webpack_public_path__ + "static/media/icon_policy_overview_bottom1_mobile.197736b0.svg";